import { vars } from '@repo/config';
import type { IAuthenticateTelegramRequest } from './authenticate-telegram-request';
import type { IAuthenticateTelegramResponse } from './authenticate-telegram-response';

export async function authenticateTelegramApi(
  body: IAuthenticateTelegramRequest,
): Promise<IAuthenticateTelegramResponse> {
  const url = new URL('/telegram/verify', vars.url.identityUrl);

  const response = await fetch(url.toString(), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  } as RequestInit);

  if (!response.ok) {
    const body = await response.text().catch(() => '');
    const err = new Error(`Telegram auth failed: ${response.status} ${body.slice(0, 200)}`);
    (err as Error & { status?: number; body?: string }).status = response.status;
    (err as Error & { status?: number; body?: string }).body = body;
    throw err;
  }

  return response.json() as Promise<IAuthenticateTelegramResponse>;
}
